import axios from '../http'
import {API} from "../const"

const api = API+'/orders';

const error = (name) => (e) => console.error(name + ':=>', e);

export function listOrders(cb, fcb = error('listOrders')) {
  axios.get(api).then(response => {
    cb(response.data);
  }).catch (err => {
    fcb(err);
  })
}

export function listOrdersStatus(cb, fcb = error('listOrdersStatus')) {
  axios.get(api+"/tabs").then(response => {
    cb(response.data);
  }).catch (err => {
    fcb(err);
  })
}

export function findAllOrders(params,cb, fcb = error('findAllOrders')) {
  axios.get(api+"/all",{params}).then(response => {
    cb(response.data);
  }).catch (err => {
    fcb(err);
  })
}

export function orderDetail(params, cb, fcb = error('orderDetail')) {
  axios.get(api + '/' + params.code).then(response => {
    cb(response.data);
  }).catch(err =>{
    fcb(err);
  })
}

export function cancelOrder(orderNo, cb , fcb = error('cancelOrder')) {
  axios.put(api+"/"+orderNo+'/cancel').then(res=>{
    cb(res)
  }).catch(err=>{
    fcb(err)
  })
}

export function oneMoreOrder(orderNo, cb , fcb = error('oneMoreOrder')) {
  axios.post(api+'/one-more-order?orderNo=' + orderNo).then(res=>{
    cb(res)
  }).catch(err=>{
    fcb(err)
  })
}


